export default __webpack_public_path__ + "static/media/dun-dun-dun.7118d210.mp3";